import { InnerBlocks } from "@wordpress/block-editor";
import { debug } from '../utilities/helpers';

function Save({ attributes }) {
  const { accordionId, backgroundColorClass = "" } = attributes;

  // debug("Accordion Parent - Save", { backgroundColorClass, accordionId });

  return (
    <div className={`accordion accordion-flush ${backgroundColorClass}`}
    id={accordionId}
>
      <InnerBlocks.Content />
    </div>
  );
}

export default Save;
